import React, { Component } from 'react'
import { connect } from 'react-redux'

import { Container, Row, Col } from '../../../SPRINTA/atoms/Grid'
import CoverImage from '../../../SPRINTA/atoms/CoverImage'
import ScrollTo from '../../../SPRINTA/atoms/ScrollTo'

import T from '../../../SPRINTA/translate/T'

import Card from '../../Components/Atom/Card'
import Placeholder from '../../../SPRINTA/atoms/PlaceHolder'

import Create from './Create'
import Copy from './Copy'
import Continue from './Continue'
import styles from './style.css'

class CreateEvent extends Component {

    state = {
        boxShow: null,
        loading: true
    }


    setBox(box) {
        this.setState({
            boxShow: box
        }, () => {
            this.scrollToStart()
        })
    }

    scrollToStart() {
        let top = this.contentBox.offsetTop
        ScrollTo(top + 70)
    }

    componentWillMount() {
        T.handleUpdate( () => this.forceUpdate() )
        this.componentWillReceiveProps( this.props )
    }

    componentWillReceiveProps( nextProps ) {
        if(nextProps.user.status === 'done') {
            if(!nextProps.user.userData)
                window.location.href = window.LOGIN_SCREEN+'?redirect_to='+window.location.href
            else
                this.setState({
                    loading: false,
                })
        }
    }

    finished(id, token) {
        this.props.history.push('/create/event/done/' + token)
    }

    render () {

        return (
            <CoverImage className={styles.bg} image={require('./background.jpg')}>
                <Container>
                    <Row>

                        {!this.state.loading ? (

                            <Col size='12 10 8' float='center'>
                                <h1>{T.text('create_your_event')}</h1>
                                <p>{T.text('create_your_event_subtitle')}</p>

                                <Row className={styles.autoHeight}>
                                    <Col size="12 4" style={{marginBottom: '20px'}}>
                                        <Card
                                            title={T.text('create_new_title')}
                                            icon="event_add"
                                            description={T.txt('create_new_description')}
                                            active={this.state.boxShow === 'create'}
                                            handleClick={() => this.setBox('create')}
                                            />
                                    </Col>
                                    <Col size="12 4" style={{marginBottom: '20px'}}>
                                        <Card
                                            title={T.text('copy_title')}
                                            icon="event_publish"
                                            description={T.text('copy_description')}
                                            active={this.state.boxShow === 'copy'}
                                            handleClick={() => this.setBox('copy')}
                                            />
                                    </Col>
                                    <Col size="12 4" style={{marginBottom: '20px'}}>
                                        <Card
                                            title={T.text('continue_title_box')}
                                            icon="event_continue"
                                            description={T.text('continue_title_box_description')}
                                            active={this.state.boxShow === 'continue'}
                                            handleClick={() => this.setBox('continue')}
                                            />
                                    </Col>
                                </Row>

                                <div ref={ref => this.contentBox = ref}>
                                    <Row>
                                        <Col>
                                            { this.state.boxShow === 'create' && (
                                                <Create handleFinished={(id, token) => {
                                                    this.finished(id, token)
                                                }}
                                                scrollToStart={() => this.scrollToStart()} />
                                            )}

                                            { this.state.boxShow === 'copy' && (
                                                <Copy handleFinished={(id, token) => {
                                                    this.finished(id, token)
                                                }}
                                                scrollToStart={() => this.scrollToStart()} />
                                            )}

                                            { this.state.boxShow === 'continue' && (
                                                <Continue handleFinished={(id, token) => {
                                                    this.finished(id, token)
                                                }}
                                                scrollToStart={() => this.scrollToStart()} />
                                            )}

                                        </Col>
                                    </Row>
                                </div>
                            </Col>

                        ) : (
                            <Col size='12 10 8' float='center'>
                                <Col size='12 4'>
                                    <Placeholder type="box" style={{height: '250px'}} />
                                </Col>
                                <Col size='12 4'>
                                    <Placeholder type="box" style={{height: '250px'}} />
                                </Col>
                                <Col size='12 4'>
                                    <Placeholder type="box" style={{height: '250px'}} />
                                </Col>

                            </Col>
                        )}

                    </Row>
                </Container>
            </CoverImage>
        )
    }
}

const mapStateToProps = store => ({
    user: store.user
})
const mapDispatchToProps = {
}
export default connect( mapStateToProps, mapDispatchToProps )(CreateEvent)



// WEBPACK FOOTER //
// ./src/App/pages/CreateEvent/index.js